import { createContext, useContext } from 'react';
import FormSpecRegistry from './FormSpecRegistry';

const FormSpecRegistryContext = createContext<FormSpecRegistry | null>(null);

export const FormSpecRegistryProvider = FormSpecRegistryContext.Provider;

/** Registry de la spec active (v2, v3, …) — fourni par `FormPEXBD_V2`. */
export const useFormSpecRegistry = (): FormSpecRegistry => {
  const registry = useContext(FormSpecRegistryContext);
  if (!registry) {
    throw new Error('useFormSpecRegistry doit être utilisé sous FormSpecRegistryProvider.');
  }
  return registry;
};

export default FormSpecRegistryContext;
